import React from "react";
import PaymentResult from "./PaymentResult";
import SawfishPaymentResult from "./SawfishPaymentResult";
import { paymentGateway } from "../../config";

const PaymentResultRouter: React.FC = () => {
  // Render appropriate component based on payment gateway from env config
  if (paymentGateway === "sawfish") {
    return <SawfishPaymentResult />;
  }

  // Default to bpoint PaymentResult
  return <PaymentResult />;
};

export default PaymentResultRouter;
